/**
 * Central configuration file.
 *
 * When moving to production, change ONLY these two values:
 *   CMS_BASE_URL  — the WordPress admin/API domain
 *   SITE_BASE_URL — the public-facing React frontend domain
 *
 * Every API call and URL conversion across the entire app
 * reads from here, so one change is all you need.
 */

// WordPress admin domain (where the CMS and REST API live)
export const CMS_BASE_URL = "https://glspharma.com";

// Public-facing React frontend domain
export const SITE_BASE_URL = "https://glspharma.com";

// Full REST API base URL (used by all API calls)
export const API_BASE_URL = `${CMS_BASE_URL}/wp-json/gls/v1`;
